export const LINKED_IN_URL_TEST_CASES = {
  valid: {
    BASE: "https://linkedin.com/in/your-profile/",
    WWW: "https://www.linkedin.com/in/flo/",
    HTTP_NO_S: "http://www.linkedin.com/in/flo/",
  },
  invalid: {
    WHATEVER_STRING: "adf1124",
    WHATEVER_URL: "https://google.com",
    INCORRECT_DOMAIN: "https://www.linkedinasdf.com/in/",
    INCORRECT_SLASH_IN: "https://www.linkedin.com/out/",
    NOTHING_AFTER_SLASH_IN_SLASH: "https://www.linkedin.com/in/",
  },
};

export const validateLinkedInURL = (url: string) => {
  const regex =
    /^$|http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+.*\/?$/;
  return url ? !regex.test(url) : false;
};

export const isValidLinkedInUrl = (url?: string | undefined | null) => {
  if (!url) {
    return false;
  }

  const regex =
    /^$|http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+.*\/?$/;
  return url ? regex.test(url) : false;
};
